// debugUtils.js
const DEBUG = process.env.PARCEL_DEBUG_MODE === 'true';

export function debugLog (...args) {
  if (DEBUG) {
    console.log(...args);
  }
};

export function debugError (...args) {
  if (DEBUG) {
    console.error(...args);
  }
};
